// import { createContext, useContext, useState, useEffect } from "react";
// import api from "../api";

// const AuthContext = createContext(null);

// export function AuthProvider({ children }) {
//   const [admin, setAdmin] = useState(() => {
//     const stored = localStorage.getItem("admin");
//     return stored ? JSON.parse(stored) : null;
//   });

//   const login = async (username, password) => {
//     const res = await api.post("/auth/login", { username, password });
//     localStorage.setItem("token", res.data.token);
//     localStorage.setItem("admin", JSON.stringify(res.data.admin));
//     setAdmin(res.data.admin);
//     return res.data.admin;
//   };

//   const logout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("admin");
//     setAdmin(null);
//   };

//   return (
//     <AuthContext.Provider value={{ admin, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export const useAuth = () => useContext(AuthContext);





import { createContext, useContext, useState } from "react";
import api from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    const stored = localStorage.getItem("admin");
    return stored ? JSON.parse(stored) : null;
  });

  const login = async (username, password) => {
    const res = await api.post("/auth/login", { username, password });
    localStorage.setItem("token", res.data.token);
    localStorage.setItem("admin", JSON.stringify(res.data.admin));
    setAdmin(res.data.admin);
    return res.data.admin;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("admin");
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);






// import { createContext, useContext, useState, useEffect } from "react";
// import api from "../api";

// const AuthContext = createContext(null);
// const TOKEN_EXPIRY_MS = 60 * 60 * 1000; // 1 hour in milliseconds

// export function AuthProvider({ children }) {
//   const [admin, setAdmin] = useState(() => {
//     const stored = localStorage.getItem("admin");
//     const loginTime = localStorage.getItem("loginTime");
//     if (stored && loginTime) {
//       const now = Date.now();
//       if (now - parseInt(loginTime) > TOKEN_EXPIRY_MS) {
//         localStorage.clear();
//         return null;
//       }
//       return JSON.parse(stored);
//     }
//     return null;
//   });

//   // Fresh login: clear old token + store timestamp
//   const login = async (username, password) => {
//     localStorage.clear();
//     setAdmin(null);

//     const res = await api.post("/auth/login", { username, password });

//     localStorage.setItem("token", res.data.token);
//     localStorage.setItem("admin", JSON.stringify(res.data.admin));
//     localStorage.setItem("loginTime", Date.now()); // store login timestamp

//     setAdmin(res.data.admin);
//     return res.data.admin;
//   };

//   const logout = () => {
//     localStorage.clear();
//     setAdmin(null);
//     window.location.href = "/login";
//   };

//   // Check token expiry every minute
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const loginTime = localStorage.getItem("loginTime");
//       if (loginTime && Date.now() - parseInt(loginTime) > TOKEN_EXPIRY_MS) {
//         logout(); // auto logout after 1 hour
//       }
//     }, 60 * 1000); // check every 1 minute

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <AuthContext.Provider value={{ admin, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export const useAuth = () => useContext(AuthContext);